import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';

import App from './App';
import reportWebVitals from './reportWebVitals';

import { Provider } from 'react-redux';

import { BrowserRouter } from "react-router-dom";

import Store from './store/configureStore';

import './i18n';
import './index.css';
import 'nprogress/nprogress.css';
import './services/setupAxiosLoadingBar';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(

        
  <Provider store={Store}>
      {/* <React.StrictMode>
          
          
        </React.StrictMode> */}
        <Suspense fallback={<div>Loading...</div>}>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </Suspense>
  </Provider>
  
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
